export const normalizeBrandsDataFromQuery = (brandsWithChildren) => {
  const items = [];

  if (brandsWithChildren) {
    for (const brand of brandsWithChildren) {
      items.push(brand);

      for (const child of brand.children) {
        items.push({ ...child, isChild: true });
      }
    }
  }

  return items;
};

export const showBrandNameWithDepth = (brand) => {
  if (brand?.isChild) {
    return `—— ${brand.name}`;
  }

  return brand.name;
};
